module.exports = "/images/home_agent_ss.png?bc0cff78206580d346c65ae829e9f0e4";